<template>
  <div class="dropdown" role="group">
      <button type="button" class="btn-block-option" id="btnGroupTabs1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa fa-calendar mr-5"></i>
          <i class="fa fa-angle-down"></i>
      </button>
      <div class="dropdown-menu" aria-labelledby="btnGroupTabs1" style="min-width: 13rem;">
          <button
            type="button"
            v-for="(range, index) in ranges"
            class="btn btn-sm btn-block btn-alt-secondary"
            tabindex="-1"
            @click="dateRange(range.value)"
            :class="{ 'active': (filter.period_start_date == range.value[0] && filter.period_end_date == range.value[1]) }"
            :key="index"
            >
            {{range.title}}
          </button>
          <div class="dropdown-divider"></div>
          <button
            type="button"
            class="btn btn-sm btn-block btn-alt-secondary"
            tabindex="-1"
            @click="dateRange([])"
            :class="{ 'active': (filter.period_start_date == '' && filter.period_end_date == '') }"
            >
            За все время
          </button>
      </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['filter'],
  data() {
    return {
      ranges: [
        {
          title: 'Сегодня',
          value: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        },
        {
          title: 'Вчера',
          value: [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
        },
        {
          title: 'Последние 7 дней',
          value: [moment().subtract(6, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        },
        {
          title: 'Последние 30 дней',
          value: [moment().subtract(29, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        },
        {
          title: 'Этот месяц',
          value: [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')],
        },
        {
          title: 'Прошлый месяц',
          value: [moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')],
        },
      ],
    };
  },
  methods: {
    dateRange(range) {
      this.$emit('input', range);
      this.$emit('datepick');
    },
  },
};
</script>
